/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */
/* istanbul ignore file */
import { ViewChild, Injectable, Directive } from '@angular/core';
import { GenericTableData } from 'src/app/sharedServices/generic-table-data.service';
import { ContentItemDto } from 'api/models';
import { AzureBlobStorageService } from 'api/services';
import { HttpClient } from '@angular/common/http';
import { CustomSnackBarComponent } from 'src/app/shared/customSnackBar/customSnackBar.component';
import { UserHandlerService } from 'src/app/sharedServices/user-handler.service';
import { LoaderService } from 'src/app/sharedServices/loader.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContentToCopyRequest } from 'api/models/content-to-copy-request';
import { BuildableContentProductRequest } from 'api/models/buildable-content-product-request';
import { SignalRService } from 'src/app/sharedServices/signal-r.service';

@Directive()
@Injectable()
// tslint:disable-next-line: directive-class-suffix
export class UploadService {
  @ViewChild(MatMenuTrigger) contextMenu: MatMenuTrigger;
  private contentItems: ContentItemDto[];
  private revitYears: string;
  private selectedFiles = [];
  private requestsLimit = 100;
  private filesUploaded = 0;
  private selectedFilesNumber = 0;
  private isUploading = false;

  constructor(
    public contentItemsManagementService: GenericTableData,
    private azureService: AzureBlobStorageService,
    private http: HttpClient,
    public signalRService: SignalRService,
    private loaderService: LoaderService,
    private userService: UserHandlerService,
    private readonly snackBar: MatSnackBar
  ) { }

  setLoaderService(isSpinning: boolean) {
    this.loaderService.display(isSpinning);
  }

  getUploadStatus() {
    return this.isUploading;
  }

  getCopyStatus(){
    return this.signalRService.canCopy;
  }


  getUserName() {
    return this.userService.getCurrentUser();
  }

  setContentItems(contentItems: ContentItemDto[]) {
    this.contentItems = contentItems;
    this.setUploadStatusForFiles();
    this.openSnackBar('Upload started');
  }

  setRevitYears(revitYears: string) {
    this.revitYears = revitYears;
  }

  onCopyItems(contentToCopyRequest: ContentToCopyRequest) {
    this.signalRService.tryStartConnection();
    this.openSnackBar('Copy Started');
    this.azureService.copyItemsToBlobStorage({
      body: contentToCopyRequest,
      userId: this.userService.getCurrentUser().userID
    }).subscribe(result => {
      this.signalRService.canCopy = false;
    });
  }

  onCopyAllItems(contentToCopyRequest: BuildableContentProductRequest) {
    this.signalRService.tryStartConnection();
    this.openSnackBar('Copy All Started');
    this.azureService.copyAllItemsToBlobStorage({
      body: contentToCopyRequest,
      userId: this.userService.getCurrentUser().userID
    }).subscribe(result => {
      this.signalRService.canCopy = false;
    });
  }

  setUploadStatusForFiles() {
    this.contentItems.forEach(element => {
      element.uploadProgress = 'Uploading';
    });
  }

  setSelectedFiles(files: any[]) {
    this.selectedFiles = files;
    this.selectedFilesNumber = files.length;
  }

  onGetUploadFiles() {
    this.contentItemsManagementService.setTableDataList(null);
    this.contentItems = new Array<ContentItemDto>();
    this.azureService
      .getUploadedFiles({
        body: this.selectedFiles.map(function (elem) {
          return elem.webkitRelativePath;
        }),
      })
      .subscribe((result) => {
        this.contentItemsManagementService.setTableDataList(result);
      });
  }

  onUploadFiles() {
    this.isUploading = true;
    const selectedFiles = this.selectedFiles.slice(0, this.requestsLimit);
    this.azureService.uploadFile({ body: { files: selectedFiles }, revitYears: this.revitYears, userName: this.getUserName().fullName })
      .subscribe(result => {
        const data = this.contentItemsManagementService.getTableData();
        result.forEach(element => {
          const dataElement = data.filter(x => x.relativeFileLocation === element.relativeFileLocation)[0];
          dataElement.uploadProgress = element.uploadProgress;
        });
        this.filesUploaded += this.requestsLimit;
        this.selectedFiles.splice(0, this.requestsLimit);
        this.openSnackBar('Uploaded ' + this.filesUploaded + ' of ' + this.selectedFilesNumber + ' files. Wait for the remaining ' + this.selectedFiles.length + ' files');
          if (this.selectedFiles.length > 0) {
          this.onUploadFiles();
        }
        else {
          this.isUploading = false;
          this.filesUploaded = 0;
          this.openSnackBar('Upload completed');
        }
      });

  }

  openSnackBar(message: string) {
    this.snackBar.openFromComponent(CustomSnackBarComponent, {
      duration: 5000,
      data: message,
    });
  }
}
